// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-cities-boston-js": () => import("./../../../src/pages/cities/boston.js" /* webpackChunkName: "component---src-pages-cities-boston-js" */),
  "component---src-pages-cities-houston-js": () => import("./../../../src/pages/cities/houston.js" /* webpackChunkName: "component---src-pages-cities-houston-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

